import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ComingSoon from './icon-coming-soon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ComingSoon {...validProps} />;
}
SvgComponent.iconName = 'coming-soon';

/**
 * @deprecated This is a legacy icon
 */
export const ComingSoonIcon = svgIconWrapper(SvgComponent);
